import React, { FC } from 'react';
import { Avatar, ListItem, ListItemAvatar, ListItemButton, ListItemText } from '@mui/material';
import ArticleIcon from '@mui/icons-material/Article';
import { HelpArticle } from 'models/zenddesk';

type ArticleListItemProps = {
    article: HelpArticle;
    onArticleClicked: (articleId: string) => void;
};
const ArticleListItem: FC<ArticleListItemProps> = ({ article, onArticleClicked }: ArticleListItemProps) => {
    return (
        <ListItem disablePadding>
            <ListItemButton onClick={() => onArticleClicked(article.articleId)}>
                <ListItemAvatar>
                    <Avatar sx={{ width: 32, height: 32 }}>
                        <ArticleIcon />
                    </Avatar>
                </ListItemAvatar>
                <ListItemText primary={article.title} />
            </ListItemButton>
        </ListItem>
    );
};

export default ArticleListItem;
